import React from "react";
import { CALENDAR_YEARS } from "src/pages/providerPayRequestDashboard/utils/dateUtils";
import { getMetricColor, getQuantityTotal, METRIC } from "./calendarUtils";
import YearSelector from "./YearSelector";
import "./YearMonthOverview.scss";

const MONTH_LABELS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

const MonthTile = ({
  label,
  month,
  value,
  hasData,
  valueColor,
  backgroundColor,
  onPress
}) => {
  return (
    <div
      className="month-overview-tile"
      style={{
        backgroundColor: hasData ? backgroundColor : "#f5f5f5",
        cursor: "pointer"
      }}
      onClick={onPress}
      role="button"
      tabIndex={0}
      aria-label={`${label} - ${value}`}
    >
      <div className="tile-month-label">{label}</div>
      <div className="tile-metric-value" style={{ color: valueColor }}>
        {value}
      </div>
    </div>
  );
};

const YearMonthOverview = ({
  selectedYear,
  monthlyData = new Map(),
  metricType,
  onYearChange,
  onMonthSelect,
  backgroundColor = "#E8F4F8",
  textColor = "#666",
  isLoading = false
}) => {
  const selectedYearIndex = CALENDAR_YEARS.indexOf(selectedYear);
  const metricColor = getMetricColor(metricType);

  const selectedYearOption = {
    title: String(selectedYear),
    id: selectedYear
  };

  const handleMonthClick = (monthIndex) => {
    onMonthSelect?.(monthIndex);
  };

  return (
    <div className="year-month-overview-container">
      <div className="overview-header">
        <div className="year-selector-wrapper">
          <YearSelector
            selectedYear={selectedYearOption}
            isLoading={isLoading}
            textColor={textColor}
            backgroundColor={backgroundColor}
            onYearSelect={onYearChange}
          />
        </div>
      </div>

      <div className="months-overview-grid">
        {MONTH_LABELS.map((label, month) => {
          const monthKey = String(month);
          const data = monthlyData.get(monthKey);
          let displayValue = "0";
          let hasData = false;

          if (data) {
            hasData = true;
            if (metricType.value === METRIC.TOTAL_AMOUNT) {
              displayValue = `$${(data.budget || 0).toFixed(2)}`;
            } else if (metricType.value === METRIC.HOURS) {
              const hours = data.hours || 0;
              const minutes = data.minutes || 0;
              displayValue = `${String(hours).padStart(2, "0")}h ${String(minutes).padStart(2, "0")}m`;
            } else if (metricType.value === METRIC.COUNT) {
              displayValue = String(data.timesheetCount || 0);
            } else if (metricType.value === METRIC.QUANTITY) {
              displayValue = String(getQuantityTotal(data.quantity));
            }
          }

          return (
            <MonthTile
              key={month}
              label={label}
              month={month}
              value={displayValue}
              hasData={hasData}
              valueColor={metricColor}
              backgroundColor={backgroundColor}
              onPress={() => handleMonthClick(month)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default YearMonthOverview;
